// extracted by mini-css-extract-plugin
export default {"titleWrap":"titleWrap---_wk5r","title":"title---lsaVc"};